export default __webpack_public_path__ + "cedc9d58c7a89f1f5ee8c1ea09f19b89.svg";